import { render, staticRenderFns } from "./StoreTable.vue?vue&type=template&id=0950ab70&scoped=true&"
import script from "./StoreTable.vue?vue&type=script&lang=js&"
export * from "./StoreTable.vue?vue&type=script&lang=js&"
import style0 from "./StoreTable.vue?vue&type=style&index=0&id=0950ab70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0950ab70",
  null
  
)

export default component.exports